import _ from 'lodash';
import { Parser } from 'formulex';

import { t } from 'i18next';
import { FORMULA_REQUIRED_CONFIG_PARAMS , FORMULA_TYPES } from '../../configs/formula';
import { getImmutableField } from './getImmutableField';
import { getValidateError } from './getValidateError';


export const validateFormula = (formula, field, fields, varAttr = 'id') => {
  if (!formula) {
    return [];
  }

  const errors = [];
  let preparedFields = fields.toJS ? fields.toJS() : _.cloneDeep(fields);
  // В случае аттрибута id, в формуле может оказаться переменная по ключу newId, поэтому добавляем филды по ключу newId
  if (varAttr === 'id') {
    preparedFields = preparedFields.reduce((acc, i) => {
      acc[i.id] = i;
      if (i.newId) {
        acc[i.newId] = i;
      }

      return acc;
    }, {});
  }

  try {
    const parser = new Parser(formula, preparedFields, varAttr);
    parser.toJs();
  } catch (e) {
    const { args, translatingId } = e;
    let text = e.message;
    if (args && translatingId) {
      text = `${t(`modals.formulaErrors.${translatingId}`, args)}`;
    }
    const error = getValidateError(field, 'formulaConfig.formula', text);
    errors.push(error);
  }

  return errors;
};

export const validateFormulaParams = (field, allFields) => {
  const immutField = getImmutableField(field);

  const formulaType = immutField.get('formulaType');

  if (formulaType !== FORMULA_TYPES.FORMULA) {
    return [];
  }

  const errors = [];
  
  if (!formulaType) {
    const error = getValidateError(immutField, 'formulaConfig', 'field with formula should be with formula type');
    errors.push(error);

    return errors;
  }

  const requiredParams = FORMULA_REQUIRED_CONFIG_PARAMS[formulaType];
  requiredParams.forEach((param) => {
    if (!immutField.getIn(['formulaConfig', param])) {
      const error = getValidateError(
        immutField,
        `formulaConfig.${param}`,
        t('modals.formulaErrors.requiredParamsError', [t(`modals.errorTypes.formulaConfig.${param}`)]),
      );
      errors.push(error);
    }
  });

  if (errors.length > 0) {
    return errors;
  }

  const formula = immutField.getIn(['formulaConfig', 'formula']);
  const formulaErrors = validateFormula(formula, immutField, allFields.toJS());

  return errors.concat(formulaErrors);
};
